<template>
  <div class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="flex flex-col items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center align-middle">
      <div class="fixed inset-0 transition-opacity bg-gray-200 bg-opacity-50 dark:bg-dark-box-background" aria-hidden="true" />
      <LogoText class="z-50 block w-48 h-auto" :dark-mode="$store.state.ui.darkMode" />
      <div class="relative flex flex-col items-center justify-center w-48 h-8">
        <div class="w-full bg-gray-200 rounded-full h-1.5 dark:bg-gray-500">
          <div class="z-50 bg-blue h-1.5 rounded-full" :style="{ width: percent + '%', transition: 'width 2s' }" />
        </div>
        <span class="block mt-5 font-bold text-gray-800 dark:text-white">{{ loadingText }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import LogoText from "@/components/shared/LogoText.vue"
export default {
  components: {
    LogoText
  },
  props: {
    percent: {
      type: Number,
      default: 0,
      required: true
    },
    loadingText: {
      type: String,
      default: "",
      required: false
    }
  }
}
</script>
